export default __webpack_public_path__ + "static/char-s-30-zh-Hant-a7d58d40ffa18f50013250f13eb9f1a5.webp";